"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EduClassUrlListRequest = void 0;
var EduClassUrlListRequest = /** @class */ (function () {
    function EduClassUrlListRequest() {
    }
    return EduClassUrlListRequest;
}());
exports.EduClassUrlListRequest = EduClassUrlListRequest;
;
//# sourceMappingURL=eduClassUrlList.request.js.map